import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const success = searchParams.get("success");
    const accessToken = searchParams.get("accessToken");
    const refreshToken = searchParams.get("refreshToken");
    const expiresAt = searchParams.get("expiresAt");
    const userParam = searchParams.get("user");

    if (success === "true" && accessToken && refreshToken && expiresAt) {
      // Parse user information
      let user = {
        id: "",
        email: "",
        name: "",
        avatarUrl: "",
      };

      if (userParam) {
        try {
          user = JSON.parse(decodeURIComponent(userParam));
        } catch (error) {
          console.error("Failed to parse user info:", error);
        }
      }

      // Store tokens in localStorage for the parent window to pick up
      const tokens = {
        accessToken,
        refreshToken,
        expiresAt: parseInt(expiresAt),
        user,
      };

      localStorage.setItem("google-oauth-tokens", JSON.stringify(tokens));

      // Close the popup window
      window.close();
    } else {
      // Handle error case
      const error = searchParams.get("error");
      console.error("OAuth error:", error);

      // Store error in localStorage
      localStorage.setItem(
        "google-oauth-error",
        error || "Authentication failed"
      );

      // Close the popup window
      window.close();
    }
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>Completing Authentication</CardTitle>
          <CardDescription>
            Please wait while we complete your Google sign-in...
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-sm text-muted-foreground">
            This window will close automatically once authentication is
            complete.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
